// extracted by mini-css-extract-plugin
export default {"disabledItem":"CopyListingMenuItem_disabledItem__TNdm8","label":"CopyListingMenuItem_label__irKI3","unavailableNote":"CopyListingMenuItem_unavailableNote__ZuNF2"};